import { render } from "./MultiFileCompenent.vue?vue&type=template&id=23ca7c68"
import script from "./MultiFileCompenent.vue?vue&type=script&lang=js"
export * from "./MultiFileCompenent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__